import React, { useState, useEffect } from "react";
import moment from "moment";
import {
  Container,
  Row,
  Col,
  Button,
  Breadcrumb,
  Modal,
  Form,
} from "react-bootstrap";

import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { blockUnblockUser, getSubadminById } from "../../../store/actions";
import {
  DataTable,
  DataTableBody,
  DataTableHead,
} from "../../../Common/DataTable";
import Loading from "../../../Common/extra/loading";

import NoImage from "../../../assest/images/noimage.jpg";
import PhoneInput from "react-phone-input-2";
import { MenuItem, Select } from "@material-ui/core";
import { Link } from "react-router-dom";

const Permissions = [
  {
    name: "Accounts",
    id: "accounts",
  },
  {
    name: "Documents",
    id: "documents",
  },
  {
    name: "Contact Messages",
    id: "contact_messages",
  },
  {
    name: "Subscribers",
    id: "subscribers",
  },
  {
    name: "Financial Questionnaire",
    id: "financial_questionnaire",
  },
  {
    name: "Sub Admin",
    id: "sub_admin",
  },
  {
    name: "Facebook",
    id: "facebook",
  },
  {
    name: "Instagram",
    id: "instagram",
  },
  {
    name: "Twitter",
    id: "twitter",
  },
  {
    name: "Youtube",
    id: "youtube",
  },
  {
    name: "Tiktok",
    id: "tiktok",
  },
  {
    name: "Template Categories",
    id: "template_categories",
  },
  {
    name: "Email Template",
    id: "email_template",
  },
  {
    name: "Document Template",
    id: "document_template",
  },
  {
    name: "Email Signature",
    id: "email_signature",
  },
  {
    name: "Notification Setting",
    id: "notification_setting",
  },
  {
    name: "Basic Setting",
    id: "basic_setting",
  },
];

const ViewSubAdminProfile = () => {
  const dispatch = useDispatch();
  const id = location.pathname.split("/")[3];

  const userData = useSelector((s) => s?.Signatures?.subadmin?.data);
  console.log(
    "🚀 ~ file: ViewSubAdminProfile.jsx:104 ~ ViewSubAdminProfile ~ userData:",
    userData
  );
  const loading = useSelector((s) => s?.Signatures?.loading);

  const [data, setData] = useState({
    userId: "",
    name: "",
    email: "",
    office_address: "",
    mobile_number: "",
    permissions: [],
    assigned_to: [],
    role: "subadmin",
  });
  console.log(
    "🚀 ~ file: ViewSubAdminProfile.jsx:120 ~ ViewSubAdminProfile ~ data:",
    data
  );

  useEffect(() => {
    if (userData) {
      setData((pre) => ({
        ...pre,
        name: userData?.name ? userData?.name : "",
        email: userData?.email ? userData?.email : "",
        address: userData?.address ? userData?.office_address : "",
        mobile_number: userData?.mobile_number
          ? "+" + userData?.mobile_number
          : "",
        permissions: userData?.permissions ? userData?.permissions : [],
        assigned_to:
          userData && userData?.clients
            ? userData?.clients.map((item) => item?.id)
            : [],
      }));
    }
  }, [userData]);

  useEffect(() => {
    if (id) {
      dispatch(getSubadminById(id));
    }

    setData((pre) => ({
      ...pre,
      userId: id,
    }));
  }, [id]);

  return (
    <>
      {loading && <Loading className={"cstmLoader"} />}
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item href="/subadmins">Sub Admin</Breadcrumb.Item>
                  <Breadcrumb.Item active>View</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="bg-white card-box px-4 py-3 rounded">
                <Form>
                  <Row>
                    <Col lg="12" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Profile Image
                      </label>
                      <div className="upload-file position-relative">
                        {/* <input
                          type="file"
                          // onChange={(e) => handleFileProvider(e)}
                          className="position-absolute"
                        /> */}
                        <div className="inner position-relative">
                          <img
                            src={
                              userData?.profile_image
                                ? userData?.profile_image
                                : "/assets/images/dummy-profile"
                            }
                            alt=""
                            className="img-fluid w-100 h-100 rounded-circle"
                          />
                          {/* <span className="btn rounded-circle d-flex align-items-center justify-content-center position-absolute">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                            >
                              <path
                                d="M5.2125 11.1975L8.3925 6.9525L14.76 1.65C15.0525 1.3575 15.54 1.3575 15.8175 1.65L16.35 2.1825C16.6425 2.46 16.6425 2.9475 16.35 3.24L11.0475 9.6075L6.8025 12.7875L5.2125 11.1975M6.27 13.32L4.68 11.73L2.5575 12.7875L1.5 15.9675L3.09 14.3775C3.24 14.25 3.4725 14.25 3.6225 14.3775C3.75 14.5275 3.75 14.76 3.6225 14.91L2.0325 16.5L5.2125 15.4425L6.27 13.32Z"
                                fill="white"
                              />
                            </svg>
                          </span> */}
                        </div>
                      </div>
                      <span className="note error_note py-2 m-0 text-danger">
                        {/* {errors.profile_image} */}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={data?.name}
                        // onChange={handleChange}
                        placeholder=""
                        className="form-control"
                        disabled
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {/* {errors.name} */}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Last Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={userData?.last_name}
                        // onChange={handleChange}
                        placeholder=""
                        className="form-control"
                        disabled
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {/* {errors.name} */}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={data?.email}
                        placeholder=""
                        className="form-control"
                        disabled
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {/* {errors.email} */}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Mobile Phone
                      </label>
                      <PhoneInput
                        country={"us"}
                        value={data.mobile_number}
                        placeholder="Mobile Phone"
                        disabled
                        // onChange={(data, country) => {
                        //   let validateWithLength = country.format?.split(".");
                        //   validateWithLength = validateWithLength?.length - 1;
                        //   if (validateWithLength == data.length) {
                        //     handlePhone(
                        //       "mobile_number",
                        //       data,
                        //       country.dialCode,
                        //       true
                        //     );
                        //   } else {
                        //     handlePhone(
                        //       "mobile_number",
                        //       data,
                        //       country.dialCode,
                        //       false
                        //     );
                        //   }
                        // }}
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {/* {errors.mobile_number} */}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Address
                      </label>
                      <input
                        type="text"
                        name="address"
                        value={userData?.office_address}
                        // onChange={handleChange}
                        placeholder=""
                        className="form-control"
                        disabled
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {/* {errors.address} */}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Fax
                      </label>
                      <input
                        type="text"
                        name="address"
                        value={userData?.fax}
                        // onChange={handleChange}
                        placeholder=""
                        className="form-control"
                        disabled
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {/* {errors.address} */}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Company Title/Position
                      </label>
                      <input
                        type="text"
                        name="address"
                        value={userData?.company_title}
                        // onChange={handleChange}
                        placeholder=""
                        className="form-control"
                        disabled
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {/* {errors.address} */}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Office No
                      </label>
                      <input
                        type="text"
                        name="address"
                        value={userData?.office}
                        // onChange={handleChange}
                        placeholder=""
                        className="form-control"
                        disabled
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {/* {errors.address} */}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Permissions
                      </label>
                      <Select
                        className="demo-simple-select-label"
                        id="demo-simple-select"
                        multiple
                        name="permissions"
                        value={data?.permissions || []}
                        // onChange={handleMultipleChange}
                        MenuProps={Permissions || []}
                        disabled
                      >
                        {Permissions &&
                          Permissions.length > 0 &&
                          Permissions.map((item, idx) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                      <span className="note error_note py-2 m-0 text-danger">
                        {/* {errors.permissions} */}
                      </span>
                    </Col>

                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Assigned to Clients
                      </label>
                      <Select
                        className="demo-simple-select-label"
                        id="demo-simple-select"
                        multiple
                        name="assigned_to"
                        value={data?.assigned_to || []}
                        // onChange={handleMultipleChange}
                        MenuProps={userData?.clients || []}
                        disabled
                      >
                        {userData &&
                          userData?.clients &&
                          userData?.clients.length > 0 &&
                          userData?.clients.map((item, idx) => {
                            console.log(item?.id, "item.idddddddddddd");
                            return (
                              <MenuItem key={item?.id} value={item?.id}>
                                {item?.amtaxsettlement_data?.FirstName +
                                  " " +
                                  item?.amtaxsettlement_data?.LastName}
                              </MenuItem>
                            );
                          })}
                      </Select>
                      <span className="note error_note py-2 m-0 text-danger">
                        {/* {errors.permissions} */}
                      </span>
                    </Col>

                    <Col lg="12" className="my-2">
                      <div className="pt-4 btn-wrp d-flex algign-items-center subadmin-back">
                        {/* <Button
                          // disabled={errors.disabled}
                          // onClick={handleSubmit}
                          className="d-flex align-items-center justify-content-center me-2"
                        >
                          Submit
                        </Button> */}
                        <Link
                          to={`/subadmins`}
                          className="btn d-flex btn-2 border align-items-center justify-content-center me-2"
                        >
                          <span className="me-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="9"
                              viewBox="0 0 12 9"
                              fill="none"
                            >
                              <path
                                d="M2.8725 3.75L5.5575 1.0575L4.5 0L0 4.5L4.5 9L5.5575 7.9425L2.8725 5.25H12V3.75H2.8725Z"
                                fill="black"
                              />
                            </svg>
                          </span>
                          Back
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default ViewSubAdminProfile;
